module.exports = __webpack_public_path__ + "static/media/nuvemshop4.d0a04cde.png";